import { Colors, Shadows } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import Media from 'builder/styles/media'

export const Container = styled.div`
  position: relative;

  .react-transform-wrapper {
    overflow: unset;
  }
`

export const CustomButton = styled.button`
  border: none;
  outline: none;
  position: absolute;
  background-color: ${Colors.White};
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: ${Shadows.lightWithBorderShadowMid};
`

export const ExpandButton = styled(CustomButton)`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${Colors.Blue50};
`

export const CloseButton = styled(CustomButton)`
  position: fixed;
  top: 24px;
  right: 20px;
  color: ${Colors.Neutral80};

  ${Media.Phone`
    top: 24px;
    right: 16px;
  `}
`
